import React from "react";

// set the defaults
const AuthContext = React.createContext({
    isAdmin: false,
    isInitialized: false
});
  
export default AuthContext;